var map = {
	"./sliding_banner_3-1.webp": 5671,
	"./sliding_banner_3-2-2.webp": 5751,
	"./sliding_banner_3-2.webp": 9952,
	"./sliding_banner_3.jpg": 2509,
	"./sliding_banner_3.webp": 135,
	"./sliding_banner_3_old.jpg": 2639,
	"./sliding_banner_4-1.webp": 3291,
	"./sliding_banner_4-2.webp": 6345,
	"./sliding_banner_4.webp": 997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7026;